import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as classnames from 'classnames';
import ColorRocket from './icons/rocket-with-color.svg';
export function ColorRocketIcon({ className, style, }) {
    return (_jsx(ColorRocket, { className: classnames('MuiSvgIcon-root', className), style: style }));
}
